import { Routes } from '@angular/router';
import { AuthGuard } from '@src/app/_guards/auth.guard';
import { UsersListComponent } from '@src/app/features/users/components/users-list/users-list.component';
import { UsersDetailComponent } from '@src/app/features/users/components/users-detail/users-detail.component';

export const USER_ROUTES: Routes = [
    {
        path: 'users',
        children: [
            {
                path: 'list',
                component: UsersListComponent,
                data: {
                    title: 'Adresář',
                    breadcrumb: [
                        {
                            label: 'Uživatelé',
                            url: '',
                        },
                        {
                            label: 'Adresář',
                            url: '',
                        },
                    ],
                },
            },
            {
                path: 'detail/:id',
                component: UsersDetailComponent,
                data: {
                    title: 'Profil uživatele',
                    breadcrumb: [
                        {
                            label: 'Uživatelé',
                            url: '',
                        },
                        {
                            label: 'Adresář',
                            url: '/users/list',
                        },
                        {
                            label: 'Profil uživatele',
                            url: '',
                        },
                    ],
                },
            },
        ],
        canActivate: [AuthGuard],
    },
];
